(function () {
  function init(root) {
    if (!root || root.dataset.rpInit === "1") return;
    root.dataset.rpInit = "1";

    const ctaLink = root.querySelector("[data-rp-cta-link]");
    const ctaStore = root.querySelector("[data-rp-cta-store]");
    const ctaLang = root.querySelector("[data-rp-cta-lang]");

    const barBtn = root.querySelector("[data-rp-toggle]");
    const barStore = root.querySelector("[data-rp-bar-store]");
    const barLang = root.querySelector("[data-rp-bar-lang]");

    const panel = root.querySelector("[data-rp-panel]");

    const storeList = root.querySelector("[data-rp-store-list]");
    const languageList = root.querySelector("[data-rp-language-list]");

    if (!ctaLink || !barBtn || !panel) return;

    function normalizePath(p) {
      if (!p) return "/";
      return p.startsWith("/") ? p : "/" + p;
    }

    function normalizeStoreBase(url) {
      return (url || "").replace(/\/+$/, "");
    }

    function normalizeLangRoot(langRoot) {
      // Shopify: l.root_url is "/" for default language, "/en" for others
      if (!langRoot) return "/";
      return langRoot.startsWith("/") ? langRoot : "/" + langRoot;
    }

    function computeHref(storeBase, langRoot, ctaPath) {
      const base = normalizeStoreBase(storeBase);
      const lr = normalizeLangRoot(langRoot).replace(/\/+$/, ""); // "/" -> "" after replace
      const path = normalizePath(ctaPath);

      // if default language => langRoot "/" => lr="" => no prefix
      const prefix = lr === "" ? "" : lr;
      return base + prefix + path;
    }

    function getCurrentLangRoot() {
      const current = root.querySelector('[data-rp-language][aria-current="true"]');
      return current?.getAttribute("data-rp-lang-root") || "/";
    }

    function open() {
      panel.hidden = false;
      root.classList.add("rp--open");
      barBtn.setAttribute("aria-expanded", "true");
      const icon = barBtn.querySelector(".rp__bar-icon");
      if (icon) icon.textContent = "▴";
    }

    function close() {
      panel.hidden = true;
      root.classList.remove("rp--open");
      barBtn.setAttribute("aria-expanded", "false");
      const icon = barBtn.querySelector(".rp__bar-icon");
      if (icon) icon.textContent = "▾";
    }

    // initial href (ensures it always follows cta_path mode)
    (function syncInitialHref() {
      const storeBase =
        root.dataset.rpSelectedStore ||
        root.dataset.rpDefaultStore ||
        ctaLink.getAttribute("href") ||
        "";

      const langRoot = getCurrentLangRoot() || root.dataset.rpLangRoot || "/";
      const ctaPath = root.dataset.rpCtaPath || "/";

      const href = computeHref(storeBase, langRoot, ctaPath);
      ctaLink.setAttribute("href", href);
    })();

    barBtn.addEventListener("click", () => {
      if (panel.hidden) open();
      else close();
    });

    // Store selection: update CTA href + labels, DO NOT navigate immediately
    if (storeList) {
      storeList.addEventListener("click", (e) => {
        const btn = e.target.closest("[data-rp-store-url]");
        if (!btn) return;

        const url = btn.getAttribute("data-rp-store-url");
        const label = btn.getAttribute("data-rp-store-label") || url;

        if (url) root.dataset.rpSelectedStore = url;

        const storeBase = url || root.dataset.rpDefaultStore || "";
        const langRoot = getCurrentLangRoot();
        const ctaPath = root.dataset.rpCtaPath || "/";

        const href = computeHref(storeBase, langRoot, ctaPath);
        ctaLink.setAttribute("href", href);

        if (ctaStore) ctaStore.textContent = label;
        if (barStore) barStore.textContent = label;

        // aria-current reset
        storeList.querySelectorAll("[aria-current]").forEach((x) => x.setAttribute("aria-current", "false"));
        btn.setAttribute("aria-current", "true");

        close();
      });
    }

    // Language selection: update CTA href + labels (NO navigation)
    if (languageList) {
      languageList.addEventListener("click", (e) => {
        const btn = e.target.closest("[data-rp-language]");
        if (!btn) return;

        const iso = btn.getAttribute("data-rp-language");
        const langLabel = btn.getAttribute("data-rp-language-label") || iso;

        // IMPORTANT: Shopify-correct prefix ("/", "/en", "/fr", ...)
        const langRoot = btn.getAttribute("data-rp-lang-root") || "/";

        if (barLang && iso) barLang.textContent = iso;
        if (ctaLang && langLabel) ctaLang.textContent = langLabel;

        const storeBase = root.dataset.rpSelectedStore || root.dataset.rpDefaultStore || "";
        const ctaPath = root.dataset.rpCtaPath || "/";

        const href = computeHref(storeBase, langRoot, ctaPath);
        ctaLink.setAttribute("href", href);

        // aria-current reset
        languageList.querySelectorAll("[aria-current]").forEach((x) => x.setAttribute("aria-current", "false"));
        btn.setAttribute("aria-current", "true");

        close();
      });
    }

    // Close panel when clicking outside
    document.addEventListener("click", (e) => {
      if (panel.hidden) return;
      if (root.contains(e.target)) return;
      close();
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && !panel.hidden) close();
    });
  }

  function initAll(container = document) {
    container.querySelectorAll("[data-region-picker]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAll(document));
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", (e) => initAll(e.target));
  document.addEventListener("shopify:section:select", (e) => initAll(e.target));
})();
